import { format } from 'date-fns';
import { z } from 'zod';

export const dateInInterval = ({
  required_error = '',
  invalid_type_error = '',
  min = new Date(),
  max,
}: {
  required_error?: string;
  invalid_type_error?: string;
  min?: Date;
  max?: Date;
}) => {
  // Normalize min and max dates to start of the day
  const normalizedMin = new Date(min);
  normalizedMin.setHours(0, 0, 0, 0);

  const normalizedMax = max ? new Date(max) : undefined;
  if (normalizedMax) {
    normalizedMax.setHours(0, 0, 0, 0);
  }

  const dateInIntervalSchema = z
    .preprocess(
      arg => {
        if (typeof arg === 'string' || arg instanceof Date) {
          const date = new Date(arg);
          if (isNaN(date.getTime())) return undefined;
          date.setHours(0, 0, 0, 0); // Normalize input date
          return date;
        }
        return undefined;
      },
      z.date({
        required_error,
        invalid_type_error,
      })
    )
    .refine(date => !normalizedMin || date >= normalizedMin, {
      message: `la date doit être le ${format(normalizedMin, 'dd/MM/yyyy')} ou une date ultérieure`,
    });

  if (normalizedMax) {
    return dateInIntervalSchema.refine(date => date <= normalizedMax, {
      message: `la date doit être le ${format(normalizedMax, 'dd/MM/yyyy')} ou une date antérieure`,
    });
  }

  return dateInIntervalSchema;
};
